export default __webpack_public_path__ + "static/media/kiss.585cf84d.mp4";